import { render, staticRenderFns } from "./AddAddress.vue?vue&type=template&id=4be6fd1c&scoped=true"
import script from "./AddAddress.vue?vue&type=script&lang=js"
export * from "./AddAddress.vue?vue&type=script&lang=js"
import style0 from "./AddAddress.vue?vue&type=style&index=0&id=4be6fd1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be6fd1c",
  null
  
)

export default component.exports